var map = {
	"./action.svg": 203,
	"./adventure.svg": 204,
	"./advertorial.svg": 205,
	"./album.svg": 206,
	"./analysis.svg": 207,
	"./anchor.svg": 208,
	"./android-block.svg": 209,
	"./android-small.svg": 210,
	"./android.svg": 211,
	"./angle-down.svg": 212,
	"./angle-left.svg": 213,
	"./angle-right.svg": 214,
	"./angle-up.svg": 215,
	"./aquarius.svg": 216,
	"./arcade.svg": 217,
	"./aries.svg": 218,
	"./arrow-down.svg": 219,
	"./arrow-left.svg": 220,
	"./arrow-right.svg": 221,
	"./arrow-up.svg": 222,
	"./arrow.svg": 223,
	"./art-director.svg": 224,
	"./astrology.svg": 225,
	"./author-avator.svg": 226,
	"./author.svg": 227,
	"./authoranchor.svg": 228,
	"./authorwhite.svg": 229,
	"./automobile.svg": 230,
	"./backward.svg": 231,
	"./bookmark.svg": 232,
	"./books-vikatan.svg": 233,
	"./brandconnect.svg": 234,
	"./breaking-news.svg": 235,
	"./bullet-arrow.svg": 236,
	"./bundle.svg": 237,
	"./business.svg": 238,
	"./calendar.svg": 239,
	"./cancel.svg": 240,
	"./cancer.svg": 241,
	"./canvas.svg": 242,
	"./capricorn.svg": 243,
	"./cartoonist.svg": 244,
	"./cinema.svg": 245,
	"./clapboard.svg": 246,
	"./clipboard.svg": 247,
	"./close.svg": 248,
	"./comment.svg": 249,
	"./corona-updates-icon.svg": 250,
	"./creative-director.svg": 251,
	"./cricket.svg": 252,
	"./crime.svg": 253,
	"./data.svg": 254,
	"./designed.svg": 255,
	"./double-arrow.svg": 256,
	"./downarrow.svg": 257,
	"./download.svg": 258,
	"./edit.svg": 259,
	"./edited-by.svg": 260,
	"./email.svg": 261,
	"./environment.svg": 262,
	"./exclusivedeals.svg": 263,
	"./facebook-bg.svg": 264,
	"./facebook-icon.svg": 265,
	"./facebook.svg": 266,
	"./filter-icon.svg": 267,
	"./filter.svg": 268,
	"./food-stylist.svg": 269,
	"./forward.svg": 270,
	"./gallery.svg": 271,
	"./game-shop.svg": 272,
	"./gemini.svg": 273,
	"./group.svg": 274,
	"./gzhome.svg": 275,
	"./gzsports.svg": 276,
	"./gztrending.svg": 277,
	"./health.svg": 278,
	"./hexbackground.svg": 279,
	"./home.svg": 280,
	"./humoursatire-entertainment.svg": 281,
	"./icon-apple.svg": 282,
	"./icon-appstore.svg": 283,
	"./icon-audio-app-store.svg": 284,
	"./icon-audio-fb.svg": 285,
	"./icon-audio-instagram.svg": 286,
	"./icon-audio-next.svg": 287,
	"./icon-audio-play-store.svg": 288,
	"./icon-audio-previous.svg": 289,
	"./icon-audio-twitter.svg": 290,
	"./icon-audio-whatsapp.svg": 291,
	"./icon-copy.svg": 292,
	"./icon-episode.svg": 293,
	"./icon-facebook.svg": 294,
	"./icon-google-play.svg": 295,
	"./icon-home-plus.svg": 296,
	"./icon-login.svg": 297,
	"./icon-open-in-new.svg": 298,
	"./icon-pause.svg": 299,
	"./icon-play.svg": 300,
	"./icon-playstore.svg": 301,
	"./icon-premium.svg": 302,
	"./icon-share.svg": 303,
	"./icon-star.svg": 304,
	"./icon-timer.svg": 305,
	"./icon-twitter.svg": 306,
	"./icon-user.svg": 307,
	"./icon-video.svg": 308,
	"./icon-whatsapp.svg": 309,
	"./illustrator-t1.svg": 310,
	"./illustrator.svg": 311,
	"./infographer.svg": 312,
	"./instagram.svg": 313,
	"./interviews.svg": 314,
	"./ios-block.svg": 315,
	"./ios-small.svg": 316,
	"./ios.svg": 317,
	"./jokes.svg": 318,
	"./leo.svg": 319,
	"./libra.svg": 320,
	"./lifestyle.svg": 321,
	"./line-arrow-next.svg": 322,
	"./line-arrow-prev.svg": 323,
	"./linkedin.svg": 324,
	"./listicle.svg": 325,
	"./live-chat.svg": 326,
	"./liveupdate.svg": 327,
	"./log green.svg": 328,
	"./log grey.svg": 329,
	"./log white.svg": 330,
	"./logic.svg": 331,
	"./login-facebook.svg": 332,
	"./login-google.svg": 333,
	"./login.svg": 334,
	"./logout-mobile.svg": 335,
	"./logout.svg": 336,
	"./longform.svg": 337,
	"./magazines.svg": 338,
	"./mail.svg": 339,
	"./menu-search.svg": 340,
	"./microphone.svg": 341,
	"./minus.svg": 342,
	"./mobile-share.svg": 343,
	"./moderated.svg": 344,
	"./more-outline.svg": 345,
	"./my-vikatan-logo.svg": 346,
	"./mynews.svg": 347,
	"./myvikatanbadge.svg": 348,
	"./narrated.svg": 349,
	"./news.svg": 350,
	"./newsletter.svg": 351,
	"./newslettericon.svg": 352,
	"./olympic.svg": 353,
	"./online-news.svg": 354,
	"./pause.svg": 355,
	"./pdf.svg": 356,
	"./pen.svg": 357,
	"./personalise.svg": 358,
	"./phone.svg": 359,
	"./photo.svg": 360,
	"./photographer.svg": 361,
	"./photostory.svg": 362,
	"./pisces.svg": 363,
	"./play.svg": 364,
	"./plus.svg": 365,
	"./podcast.svg": 366,
	"./podcast_vikatan_menu.svg": 367,
	"./poems.svg": 368,
	"./politics.svg": 369,
	"./premium.svg": 370,
	"./producer.svg": 371,
	"./proofread.svg": 372,
	"./published-by.svg": 373,
	"./published.svg": 374,
	"./rain.svg": 375,
	"./rss.svg": 376,
	"./rupee.svg": 377,
	"./sagitarius.svg": 378,
	"./scorpio.svg": 379,
	"./script-writer.svg": 380,
	"./scripted.svg": 381,
	"./search.svg": 382,
	"./share-alt.svg": 383,
	"./share.svg": 384,
	"./sharechat.svg": 385,
	"./shortform.svg": 386,
	"./shortstories.svg": 387,
	"./shortvideo.svg": 388,
	"./slider-next.svg": 389,
	"./slider-prev.svg": 390,
	"./socialshare.svg": 391,
	"./sort.svg": 392,
	"./sound.svg": 393,
	"./speaker.svg": 394,
	"./speakeraudio.svg": 395,
	"./spiritual.svg": 396,
	"./sponsored.svg": 397,
	"./sports.svg": 398,
	"./star.svg": 399,
	"./stories.svg": 400,
	"./strategy.svg": 401,
	"./stylist.svg": 402,
	"./subscribe-vikatan.svg": 403,
	"./success-icon.svg": 404,
	"./tag.svg": 405,
	"./taurus.svg": 406,
	"./technology.svg": 407,
	"./text.svg": 408,
	"./textsms.svg": 409,
	"./thodargal.svg": 410,
	"./thump.svg": 411,
	"./tick.svg": 412,
	"./trending.svg": 413,
	"./twitter-icon.svg": 414,
	"./twitter.svg": 415,
	"./uparrow.svg": 416,
	"./update-black.svg": 417,
	"./user-square.svg": 418,
	"./user.svg": 419,
	"./v-plus-logo.svg": 420,
	"./video-editor.svg": 421,
	"./video-icon.svg": 422,
	"./video-play.svg": 423,
	"./video.svg": 424,
	"./videographer.svg": 425,
	"./vikatan-play-logo-red.svg": 426,
	"./vikatan-play.svg": 427,
	"./vikatan-tv.svg": 428,
	"./vikatan.svg": 429,
	"./vikatanconnect.svg": 430,
	"./vikatanplay.svg": 431,
	"./vikatanspl.svg": 432,
	"./vikatantv.svg": 433,
	"./virgo.svg": 434,
	"./whatsapp-icon.svg": 435,
	"./whatsapp-icon1.svg": 436,
	"./whatsapp.svg": 437,
	"./women-home.svg": 438,
	"./writtenarticles.svg": 439,
	"./writtenstory.svg": 440,
	"./youtube.svg": 441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 202;